import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from "firebase/messaging";
const API_PATH="https://brsinbox.com/API/";
const firebaseConfig = {
  apiKey: "AIzaSyA_vOiieNYK05ARHwN4wnsU9olRD2XRFu0",
  authDomain: "myspear-d131d.firebaseapp.com",
  databaseURL: "https://myspear-d131d.firebaseio.com",
  projectId: "myspear-d131d",
  storageBucket: "myspear-d131d.appspot.com",
  messagingSenderId: "15506651380",
  appId: "1:15506651380:web:92eab1b1679e83743a06a1",
  measurementId: "G-8QK8QJ1LQ0"
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

//console.log(messaging.subscribe_to_topic);

const isSupported = () =>
'Notification' in window &&
'serviceWorker' in navigator &&
'PushManager' in window


//export const requestForToken = (setTokenFound) => {
export const requestForToken = () => {
  return getToken(messaging, {vapidKey: 'BFG6YNRSJ2c1WsSShLATRW7978XG0ECUd2_tstzIJfVHNJW7FLzJS5-zNFKmzt4pW5yJiLripk7decnSLc4qJtI'}).then((currentToken) => {
    if (currentToken) {
      //console.log('current token for client: ', currentToken);
	  saveTokenToDatabase(currentToken);
     // setTokenFound(true);
      // Track the token -> client mapping, by sending to backend server
      // show on the UI that permission is secured
    } else {
      console.log('No registration token available. Request permission to generate one.');
     // setTokenFound(false);
	  // saveTokenToDatabase('No registration token available. Request permission to generate one.');
      // shows on the UI that permission is required 
    }
  }).catch((err) => {
    console.log('An error occurred while retrieving token. ', err);
	//alert('err');
	//alert(err);
	if (isSupported()) {
	   const hasPermission = Notification.permission === 'granted'
	   //alert(hasPermission);
	   if(hasPermission){
	     requestForToken();
	   }else{
		  //requestForToken();
	   }
	}
	
	 //saveTokenToDatabase(err);
	//requestForToken(false);
	//window.location.reload();
    // catch error while creating client token
  });
}
 


export const onMessageListener = () =>
  new Promise((resolve) => {    
    onMessage(messaging, (payload) => {
		console.log('Message received. ', payload);
      resolve(payload);
    });
  });
  
    
 function saveTokenToDatabase(token) {
		const mno=localStorage.getItem('_tm_lmno');
		const acnt_1=localStorage.getItem('_tm_laccId');
		const ownerId=acnt_1?acnt_1:2329;
        const _stage_vrf="Y";
		  localStorage.setItem("_token_str_"+mno,token);
		  var formData = new FormData();
		  formData.append("token", token);
		  formData.append("mno", mno);
		  formData.append("ownerId", ownerId);
		  formData.append("_stage_vrf", _stage_vrf);
          fetch(API_PATH+"save_token.php",{
			method: "POST",
			dataType: "json",
			/*headers: {
			"Content-Type": "application/json",
			},
			body: JSON.stringify({ token }),*/
			body: formData,
			}
			).then(response =>response.json()).then((data) => {
				 if(data.status === 1){
						var listArr = data.topicList;
						const responseData25 = JSON.stringify(listArr);
					    localStorage.setItem('group_topics_'+ownerId,responseData25);
						if(responseData25 !== 'undefined' && responseData25 !== null && responseData25!=='' && responseData25!=='[]'){
							if(listArr.length>0){ 
								listArr.map((cell, i) => {
									//subscribeTokenToTopic(token,cell);
									return null;
								}); 
							}
					    }
				 }
			})
			.catch((error) => {
			  console.error(error.result);
			});
			
			//subscribeTokenToTopic(token,"/spearon/topic1")
			//subscribeTokenToTopic(token,"spearon_mmr1");
	//}
	return true;
  
}


/* function subscribeTokenToTopic(token, topic) {
	
	  //const FCM_SERVER_KEY="AAAAA5xEuPQ:APA91bHVllCwR33pt4uYYTr_1sTAdnDAo40kdzcrgd2E2fo33HHeVJck3xkraVLw6AjTLbfvz2ndqiMLX4ziZhfs1PoY-PjSU1bKFNJt6MbxSiaeQqaoNANhTZHt_LiGmfLb8a1sSfxV";
	
          fetch(`https://iid.googleapis.com/iid/v1/${token}/rel/topics/${topic}`, {
            method: 'POST',
            headers: { 
    'Authorization': 'Bearer ya29.c.c0ASRK0GZZh-DV34UEtPO0_zKc5vkfdly80pjzpK9HuiO_89ozAsez4242uALpa6J5Imav7E2nC0p4YCalV4n9RHkjYCXFFUgrNI3CpIvEhDAVaEArWsaED9FrdaDVlSQFss3L0UAPNwwk9lYtqTrVjjunHrz3DrRLItusYUF9AtZ214n-K1zD70z1jWO1Bt0ohtd_5g2-0nqgAdRqDRVjHKWt7YfFubgMP-bwSqSRwn897yEKkPqBacQYXoBtfvGf4zOBo9UgsS5txU60-YHCQSvMm6NZegdB-C0kEa-W2LWbC3quByk2ibEc5gR99t8agiGoHX3WoKL08ULQDAs1N5NBnKks65p2KWVPTVhuYs4WdEbEx8HKTA8E384CYpWRJwhzpUs7MIduBuk-765J4pmZSxa7-yitXowQO88MQ1YQ122uQMlyltY4soVp-VoFkbJVaJhwfgB5W38b_o5qZzf14Qq_b23yS2SR21USssyOaftFmWU1ZaJ6wqabM1vFSpWZ9oxMJ88-tOd1f9s2dxoM32B4px0MfnQ2as5-2suXYzdkJ5egSXhej0VrealQZ5zO2XIw8QeSwwfd93MfdJ72e3U6u99uUYowY97vYoxb3u3kh8IMkJOiuSxRq995hdZtO72xsyUz-alXY1uX3jFirwi7J-MqWnrhB7R9I1tdp3_ejvw6bbcpJ_OvRmkJrlUOUIU_yFwIVbXrWv40MZgy-gQevdemfBuI5dotglz-_6Qdn2ymexIO2sfd2inM3yloVwt19ZQRSdVw6bUOMvMQMkxj3QJ8jeI0pV6RI9j4l689YQZunixFbqvY6u2UtzgkUq_0XuvyhFt3vvZzlj29aegyzi889tsrIyobJoQg7fF8FUwZlY2t5enb9gfs3_5a1l1rfrgSwSu9og7JUhdSwsi97qVwtjVB9qO6gR85Mrq29kXdysXpp3m_URY3kQzq9Vp82uqeOM-UVmb-zSSpQnhk9vZY0U7JfloIY6ufhxu1ja4v6Vx', 
    'Content-Type': 'application/json', 
    'Content-Length': '0',
	'access_token_auth':'true'
  }
          })
            .then((response) => {
              if (response.status < 200 || response.status >= 400) {
                console.log(response.status, response);
              }
              console.log(`"${topic}" is subscribed`);
            })
            .catch((error) => {
              console.error(error.result);
            });
          return true;
		  
} */